<script setup>
import TrackTypeIcon from "@/Components/TrackTypeIcon.vue";
import { formatTrackNavigateBy } from "@/Helpers/helperFunctions";

defineProps({
    navigateBy: { type: String, default: null },
});
</script>

<template>
    <span
        v-if="navigateBy === 'rb' || navigateBy === 'gpx'"
        class="inline-flex items-center gap-2 whitespace-nowrap align-middle"
        :title="formatTrackNavigateBy(navigateBy)"
    >
        <TrackTypeIcon :type="navigateBy" />
        {{ formatTrackNavigateBy(navigateBy) }}
    </span>
</template>
